import React, { createContext, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [userLoggedIn, setUserLoggedIn] = useState(localStorage.getItem("userLoggedIn") === "true");

    const pData = localStorage.getItem("userProfileData") ? JSON.parse(localStorage.getItem("userProfileData")) : {}

    const [userProfileData, setUserProfileData] = useState(pData);

    return (
        <>
            <AuthContext.Provider value={{userLoggedIn, setUserLoggedIn, userProfileData, setUserProfileData}}>
                {children}
            </AuthContext.Provider>
        </>
    )
}

export { AuthContext, AuthProvider };
